import { isHTMLContentEmpty } from "helpers/common";
import errorMessages from "utils/validation/errorMessages";
import { emailSchema, phoneRequiredSchema, select2RequiredSchema, stringOptionalSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { array, object, string } from 'yup';

const profileSchema = object().shape({
	firstname: stringRequiredSchema,
	lastname: stringRequiredSchema,
	phone: phoneRequiredSchema,
	email: emailSchema,
	signature_img: stringRequiredSchema.url(errorMessages.url),
	email_signature: string().test(
		"email-signature-required",
		"Email signature is required",
		(value) => {
			if (!value || isHTMLContentEmpty(value)) {
				return false;
			}
			return true;
		}
	),
	emergency_firstname: stringRequiredSchema,
	emergency_lastname: stringRequiredSchema,
	emergency_email: emailSchema,
	emergency_phone: phoneRequiredSchema,
	emergency_relationship: stringRequiredSchema,

});

export default profileSchema;